import React, { useState, useEffect } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";

import {
  OPContainer,
  OPBox,
  OPHeader,
  OPTitle,
  Volume,
  OPWrapper,
} from "./SettingsStyled";
import ToggleSwitch from "./ToggleSwitch";

export default ({
  handleAbove,
  userSettings,
  saveUserSettings,
  handleAboveAnimation,
  handleSettingsAnimation,
  settingsAnim,
  handleVolumeLocal,
  audio,
  // volumeLocal,
}) => {
  const [music, setmusic] = useState(userSettings.music);
  const [sound, setsound] = useState(userSettings.sound);
  const [volume, setvolume] = useState(userSettings.volume);

  const [closeBtn, setclosebtn] = useState(false);
  const [provAnim, setprovAnim] = useState(false);
  const [ruleAnim, setRuleAnim] = useState(false);
  const [historyAnim, setHistoryAnim] = useState(false);

  const [soundPlayed, setSoundPlayed] = useState(false);

  useEffect(() => {
    setmusic(userSettings.music);
    setsound(userSettings.sound);
    setvolume(userSettings.volume);
  }, [userSettings]);
  const handleSavingSettings = (arr) => saveUserSettings(arr);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  return (
    <OPContainer settingsAnim={settingsAnim}>
      <OPWrapper>
        <OPBox settingsAnim={settingsAnim}>
          <OPHeader
            close={closeBtn}
            settingsAnim={settingsAnim}
            soundPlayed={soundPlayed}
          >
            <p>Settings</p>
            <span
              onClick={() => {
                setAnimation(closeBtn, setclosebtn);
                audio.goBack();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleSettingsAnimation(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 400);
                }, 150);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <OPTitle
            prov={provAnim}
            onClick={() => {
              setAnimation(provAnim, setprovAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("provFair");
                handleAboveAnimation(true);
                handleSettingsAnimation(false);
              }, 100);
            }}
          >
            Provably Fair
          </OPTitle>
          <OPTitle
            rules={ruleAnim}
            onClick={() => {
              setAnimation(ruleAnim, setRuleAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("gameRules");
                handleAboveAnimation(true);
                handleSettingsAnimation(false);
              }, 100);
            }}
          >
            Game Rules
          </OPTitle>
          <OPTitle
            history={historyAnim}
            onClick={() => {
              setAnimation(historyAnim, setHistoryAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("history");
                handleAboveAnimation(true);
                handleSettingsAnimation(false);
              }, 100);
            }}
          >
            History
          </OPTitle>
          <ToggleSwitch
            name={"Music"}
            isOn={music === "1"}
            myVolume={userSettings.volume}
            playSwitchSound={() => music === "0" && audio.switch()}
            save={() =>
              handleSavingSettings([music === "1" ? "0" : "1", sound, volume])
            }
          />
          <br />
          <ToggleSwitch
            name={"Sound"}
            isOn={sound === "1"}
            myVolume={userSettings.volume}
            playSwitchSound={() => audio.switch()}
            save={() =>
              handleSavingSettings([music, sound === "1" ? "0" : "1", volume])
            }
          />
          <br />
          <Volume
            saveUserSetting={(v) => handleSavingSettings([music, sound, v])}
            value={volume}
            handleVolumeLocal={handleVolumeLocal}
          />
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
